import * as React from "react"

function SvgEdit(props) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.434 7.781L9.649 0l.017.018c.12-.043.51-.05 1.45.923.94.973.914 1.358.865 1.474v.001a.122.122 0 01-.027.042l-.008-.009-8.233 7.799c-.087-.432-.405-.963-.807-1.417-.485-.55-1.046-.942-1.472-1.05zM.9 8.991l.09-.295.11-.369c-.006-.081.006-.139.034-.165h.001c.019-.017.055-.02.082-.02.268 0 .846.332 1.39.947.523.592.723 1.1.733 1.357.003.08-.011.136-.041.162-.024.02-.064.025-.094.025a.394.394 0 01-.063-.008l-.013-.002-.426.05-.316.037-1.448.168v-.001l.001-.001a.476.476 0 00-.135-.336c-.046-.053-.167-.169-.318-.18L.9 8.992zm-.433 1.583a.049.049 0 00-.032.01l-.356.295c-.038.032-.125.224-.05.31.03.034.081.046.135.046a.37.37 0 00.186-.046l.356-.294.002-.005.002-.005c.027-.037-.001-.123-.07-.203-.056-.063-.12-.102-.165-.106l-.008-.002z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgEdit
